import { saveAs } from 'file-saver';
import moment from 'moment';
import { combineReducers } from 'redux';

import OrderTypes from './types';

const exportOrders = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case request:
        return { ...state, isFetching: true };
      case success:
        const dateExport = moment(new Date()).format('DD-MM-YYYY');
        let fileExport = new Blob([action.payload], { type: 'text/csv; charset=utf-8' });
        saveAs(fileExport, `minhas-entregas-${dateExport}.csv`);
        return { ...state, isFetching: false };
      case error:
        return { ...state, isFetching: false };
      default:
        return state;
    }
  };
};

export const orderReducer = combineReducers({
  list: OrderTypes.list.getReducer(),
  schedule: OrderTypes.schedule.getReducer(),
  items: OrderTypes.items.getReducer(),
  itemtrack: OrderTypes.itemtrack.getReducer(),
  batch: OrderTypes.batch.getReducer(),
  sent: OrderTypes.sent.getReducer(),
  products: OrderTypes.products.getReducer(),
  status: OrderTypes.status.getReducer(),
  export: OrderTypes.export.createReducer(exportOrders),
});
